import React from 'react'
import './ConfirmationInfo.css'

function ConfirmationInfoBrokerage(props) {
  return (
    <>


          <tr>
            <td className='td-title-text'>
              <span className='title-text'>Freight Bill Number: </span>
              <span className='info-text'>
                {props.confirmationData?.systemOrderNumber}
              </span>
            </td>
          </tr>
    </>
  )
}

export default ConfirmationInfoBrokerage
